<template>
  <router-view></router-view>
</template>

<script>
export default {
  setup() {
    // app.vue写在script里面  main.js写在app挂载完之后
    const debounce = (fn, delay) => {
      let timer
      return (...args) => {
        if (timer) {
          clearTimeout(timer)
        }
        timer = setTimeout(() => {
          fn(...args)
        }, delay)
      }
    }
    const _ResizeObserver = window.ResizeObserver
    window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
      constructor(callback) {
        callback = debounce(callback, 200)
        super(callback)
      }
    }
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  outline: none;
}

//自定义一个字体类型
@font-face {
  font-family: 'bing';
  src: url(./assets/font/youzikulongcangti.ttf);
}

@font-face {
  font-family: 'aing';
  src: url(./assets/font/sanjijinyixingkaiti.ttf);
}

@font-face {
  font-family: 'hanyiwen';
  src: url(./assets/font/hanyiwenrunsongyun.ttf);
}

.search {
  padding: 20px 0;
  margin-left: 8px;
  padding-bottom: 10px;
  font-size: 16px;
  color: #666;
  display: flex;
  align-items: center;
  //background: #A9987C;
  .spanClass{
    margin-left: 8px;
  }
  .btn{
    margin-left: 8px;
  }
}
.addButtonClass{
  padding-bottom: 8px;
}
.bottom{
  margin-left: 20px;
  padding: 20px 0;
}


</style>
